import { MailOpen } from "lucide-react";
import { useState, useEffect } from "react";
import Navbar from "../../../components/layout/Navbar";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import supabase from "../../../helper/supabaseClient";

const CheckReset = () => {
  const [email, setEmail] = useState<string>("");
  const [hasResentMail, setHasResentMail] = useState(false);
  const [isLoading, setIsLoading]= useState(false)
  useEffect(() => {
    // Get email from local storage that was set in the ResetPassword component
    const storedEmail = localStorage.getItem("resetEmail");
    if (storedEmail) {
      setEmail(storedEmail);
    }
  }, []);

  const handleResendEmail = async () => {
    if (hasResentMail) {
      toast.error(
        "You have already resent the reset email. Wait a few minutes before trying again."
      );
      return;
    }

    if (!email) {
      toast.error("No email found — please go back and enter your email again.");
      return;
    }

    try {

      setIsLoading(true)
      const { error } = await supabase.auth.resetPasswordForEmail(email);

      if (error) {
        console.error("Supabase error:", error);
        toast.error(error.message || "Failed to resend reset email");
        return;
      }

      toast.success("Password reset email sent!");
      setHasResentMail(true);

      // Prevent spamming resend
      setTimeout(() => setHasResentMail(false), 5 * 60 * 1000);
    } catch (err) {
      console.error("Unexpected error:", err);
      toast.error("Something went wrong. Please try again.");
    }
    finally{
      setIsLoading(false)
    }
  };

  return (
    <div>
      <Navbar />
      <div className="p-5 sm:p-14 h-[81vh] flex items-start md:items-center justify-center landing-bg bg-cover bg-no-repeat bg-center">
        <div className="w-full md:w-fit flex items-center justify-center flex-col bg-white">
          <div className=" sm:p-10 rounded-2xl sm:border border-[#7E57C233]  w-[100%] sm:w-[80%] md:w-fit flex items-center justify-between gap-20 ">
            <div className="flex flex-col gap-6 items-start justify-start w-[500px]">
              <h2 className=" flex items-center justify-center gap-2">
                Check email <MailOpen />
              </h2>
              <div className="flex flex-col items-start justify-center gap-5 w-full">
                <span className="text-[16px]">
                  A password reset email has been sent to:{" "}
                  <span className="font-medium text-[16px]">{email}</span>
                </span>
                <span className="flex  items-center justify-center gap-1">
                  Haven't seen email or wrong email?
                  <span
                    className="text-[#945bf5] cursor-pointer"
                    onClick={handleResendEmail}
                  >
                    {isLoading ? "Sending..." : "Send new"}
                  </span>
                  or
                  <Link to="/reset-password" className="text-[#945bf5]">
                    {" "}
                    edit email
                  </Link>
                </span>
              </div>
            </div>
            <img
              src="/assets/Jellosite-Logo-09.jpg"
              alt=""
              className="w-[250px] hidden md:block"
            />
          </div>
          <ul className="text-[#666666] md:w-full hidden sm:flex gap-3.5 sm:w-[80%]  items-center justify-end mt-1 ">
            <Link to="/privacy_policy">
              <li>Privacy</li>
            </Link>
            <Link to="/terms_conditions">
              <li>Terms</li>
            </Link>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default CheckReset;
